/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { PersonnePhysiquePlaquePersonnePhysiqueDto } from '../models/personne-physique-plaque-personne-physique-dto';


/**
 * Fonctions de gestion des associations des plaques aux personnes physiques
 */
@Injectable({
  providedIn: 'root',
})
export class PersonnesPhysiquesPlaquesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation personnePhysiquePlaquePersonnePhysiqueGetList
   */
  static readonly PersonnePhysiquePlaquePersonnePhysiqueGetListPath = '/api/personnes-physiques-plaques/list';

  /**
   * Renvoie la liste des plaques de personnes physiques.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiquePlaquePersonnePhysiqueGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiquePlaquePersonnePhysiqueGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PersonnePhysiquePlaquePersonnePhysiqueDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesPlaquesService.PersonnePhysiquePlaquePersonnePhysiqueGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PersonnePhysiquePlaquePersonnePhysiqueDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des plaques de personnes physiques.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiquePlaquePersonnePhysiqueGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiquePlaquePersonnePhysiqueGetList(params?: {
  }): Observable<Array<PersonnePhysiquePlaquePersonnePhysiqueDto>> {

    return this.personnePhysiquePlaquePersonnePhysiqueGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PersonnePhysiquePlaquePersonnePhysiqueDto>>) => r.body as Array<PersonnePhysiquePlaquePersonnePhysiqueDto>)
    );
  }

  /**
   * Path part for operation personnePhysiquePlaquePersonnePhysiqueGetList2
   */
  static readonly PersonnePhysiquePlaquePersonnePhysiqueGetList2Path = '/api/personnes-physiques-plaques/personne/list/{personnePhysiqueId}';

  /**
   * Renvoie la liste des plaques de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiquePlaquePersonnePhysiqueGetList2()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiquePlaquePersonnePhysiqueGetList2$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;
  }): Observable<StrictHttpResponse<Array<PersonnePhysiquePlaquePersonnePhysiqueDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesPlaquesService.PersonnePhysiquePlaquePersonnePhysiqueGetList2Path, 'get');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PersonnePhysiquePlaquePersonnePhysiqueDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des plaques de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiquePlaquePersonnePhysiqueGetList2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiquePlaquePersonnePhysiqueGetList2(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;
  }): Observable<Array<PersonnePhysiquePlaquePersonnePhysiqueDto>> {

    return this.personnePhysiquePlaquePersonnePhysiqueGetList2$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PersonnePhysiquePlaquePersonnePhysiqueDto>>) => r.body as Array<PersonnePhysiquePlaquePersonnePhysiqueDto>)
    );
  }

  /**
   * Path part for operation personnePhysiquePlaquePersonnePhysiqueLoadList
   */
  static readonly PersonnePhysiquePlaquePersonnePhysiqueLoadListPath = '/api/personnes-physiques-plaques/load-list';

  /**
   * Renvoie la liste des plaques de personnes physiques (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiquePlaquePersonnePhysiqueLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiquePlaquePersonnePhysiqueLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesPlaquesService.PersonnePhysiquePlaquePersonnePhysiqueLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des plaques de personnes physiques (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiquePlaquePersonnePhysiqueLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiquePlaquePersonnePhysiqueLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnePhysiquePlaquePersonnePhysiqueLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnePhysiquePlaquePersonnePhysiqueLoadList2
   */
  static readonly PersonnePhysiquePlaquePersonnePhysiqueLoadList2Path = '/api/personnes-physiques-plaques/personne/load-list/{personnePhysiqueId}';

  /**
   * Renvoie la liste des plaques de la personne physique spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiquePlaquePersonnePhysiqueLoadList2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiquePlaquePersonnePhysiqueLoadList2$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesPlaquesService.PersonnePhysiquePlaquePersonnePhysiqueLoadList2Path, 'post');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des plaques de la personne physique spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiquePlaquePersonnePhysiqueLoadList2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiquePlaquePersonnePhysiqueLoadList2(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnePhysiquePlaquePersonnePhysiqueLoadList2$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnePhysiquePlaquePersonnePhysiqueGet
   */
  static readonly PersonnePhysiquePlaquePersonnePhysiqueGetPath = '/api/personnes-physiques-plaques/personne/{personnePhysiqueId}/{id}';

  /**
   * Renvoie la plaque de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiquePlaquePersonnePhysiqueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiquePlaquePersonnePhysiqueGet$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de la plaque de la personne physique
     */
    id: number;
  }): Observable<StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesPlaquesService.PersonnePhysiquePlaquePersonnePhysiqueGetPath, 'get');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Renvoie la plaque de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiquePlaquePersonnePhysiqueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiquePlaquePersonnePhysiqueGet(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de la plaque de la personne physique
     */
    id: number;
  }): Observable<PersonnePhysiquePlaquePersonnePhysiqueDto> {

    return this.personnePhysiquePlaquePersonnePhysiqueGet$Response(params).pipe(
      map((r: StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>) => r.body as PersonnePhysiquePlaquePersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation personnePhysiquePlaquePersonnePhysiquePut
   */
  static readonly PersonnePhysiquePlaquePersonnePhysiquePutPath = '/api/personnes-physiques-plaques/personne/{personnePhysiqueId}/{id}';

  /**
   * Met à jour la plaque de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiquePlaquePersonnePhysiquePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiquePlaquePersonnePhysiquePut$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de la plaque de la personne physique
     */
    id: number;

    /**
     * Plaque de la personne physique
     */
    body: PersonnePhysiquePlaquePersonnePhysiqueDto
  }): Observable<StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesPlaquesService.PersonnePhysiquePlaquePersonnePhysiquePutPath, 'put');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Met à jour la plaque de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiquePlaquePersonnePhysiquePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiquePlaquePersonnePhysiquePut(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de la plaque de la personne physique
     */
    id: number;

    /**
     * Plaque de la personne physique
     */
    body: PersonnePhysiquePlaquePersonnePhysiqueDto
  }): Observable<PersonnePhysiquePlaquePersonnePhysiqueDto> {

    return this.personnePhysiquePlaquePersonnePhysiquePut$Response(params).pipe(
      map((r: StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>) => r.body as PersonnePhysiquePlaquePersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation personnePhysiquePlaquePersonnePhysiqueGet2
   */
  static readonly PersonnePhysiquePlaquePersonnePhysiqueGet2Path = '/api/personnes-physiques-plaques/{id}';

  /**
   * Renvoie la plaque de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiquePlaquePersonnePhysiqueGet2()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiquePlaquePersonnePhysiqueGet2$Response(params: {

    /**
     * Identifiant de la plaque de la personne physique
     */
    id: number;
  }): Observable<StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesPlaquesService.PersonnePhysiquePlaquePersonnePhysiqueGet2Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Renvoie la plaque de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiquePlaquePersonnePhysiqueGet2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiquePlaquePersonnePhysiqueGet2(params: {

    /**
     * Identifiant de la plaque de la personne physique
     */
    id: number;
  }): Observable<PersonnePhysiquePlaquePersonnePhysiqueDto> {

    return this.personnePhysiquePlaquePersonnePhysiqueGet2$Response(params).pipe(
      map((r: StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>) => r.body as PersonnePhysiquePlaquePersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation personnePhysiquePlaquePersonnePhysiquePut2
   */
  static readonly PersonnePhysiquePlaquePersonnePhysiquePut2Path = '/api/personnes-physiques-plaques/{id}';

  /**
   * Met à jour la plaque de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiquePlaquePersonnePhysiquePut2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiquePlaquePersonnePhysiquePut2$Response(params: {

    /**
     * Identifiant de la plaque de la personne physique
     */
    id: number;

    /**
     * Plaque de la personne physique
     */
    body: PersonnePhysiquePlaquePersonnePhysiqueDto
  }): Observable<StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesPlaquesService.PersonnePhysiquePlaquePersonnePhysiquePut2Path, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Met à jour la plaque de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiquePlaquePersonnePhysiquePut2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiquePlaquePersonnePhysiquePut2(params: {

    /**
     * Identifiant de la plaque de la personne physique
     */
    id: number;

    /**
     * Plaque de la personne physique
     */
    body: PersonnePhysiquePlaquePersonnePhysiqueDto
  }): Observable<PersonnePhysiquePlaquePersonnePhysiqueDto> {

    return this.personnePhysiquePlaquePersonnePhysiquePut2$Response(params).pipe(
      map((r: StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>) => r.body as PersonnePhysiquePlaquePersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation personnePhysiquePlaquePersonnePhysiquePost
   */
  static readonly PersonnePhysiquePlaquePersonnePhysiquePostPath = '/api/personnes-physiques-plaques/personne';

  /**
   * Crée la plaque de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiquePlaquePersonnePhysiquePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiquePlaquePersonnePhysiquePost$Response(params: {

    /**
     * Plaque de la personne physique
     */
    body: PersonnePhysiquePlaquePersonnePhysiqueDto
  }): Observable<StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesPlaquesService.PersonnePhysiquePlaquePersonnePhysiquePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Crée la plaque de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiquePlaquePersonnePhysiquePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiquePlaquePersonnePhysiquePost(params: {

    /**
     * Plaque de la personne physique
     */
    body: PersonnePhysiquePlaquePersonnePhysiqueDto
  }): Observable<PersonnePhysiquePlaquePersonnePhysiqueDto> {

    return this.personnePhysiquePlaquePersonnePhysiquePost$Response(params).pipe(
      map((r: StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>) => r.body as PersonnePhysiquePlaquePersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation personnePhysiquePlaquePersonnePhysiqueLoadListByPlaque
   */
  static readonly PersonnePhysiquePlaquePersonnePhysiqueLoadListByPlaquePath = '/api/personnes-physiques-plaques/plaque/load-list/{plaquePersonnePhysiqueId}';

  /**
   * Renvoie la liste des personnes physiques liées à la plaque spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiquePlaquePersonnePhysiqueLoadListByPlaque()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiquePlaquePersonnePhysiqueLoadListByPlaque$Response(params: {

    /**
     * Identifiant de la plaque personne physique
     */
    plaquePersonnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesPlaquesService.PersonnePhysiquePlaquePersonnePhysiqueLoadListByPlaquePath, 'post');
    if (params) {
      rb.path('plaquePersonnePhysiqueId', params.plaquePersonnePhysiqueId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des personnes physiques liées à la plaque spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiquePlaquePersonnePhysiqueLoadListByPlaque$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiquePlaquePersonnePhysiqueLoadListByPlaque(params: {

    /**
     * Identifiant de la plaque personne physique
     */
    plaquePersonnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnePhysiquePlaquePersonnePhysiqueLoadListByPlaque$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnePhysiquePlaquePersonnePhysiqueGetByPlaque
   */
  static readonly PersonnePhysiquePlaquePersonnePhysiqueGetByPlaquePath = '/api/personnes-physiques-plaques/plaque/{plaquePersonnePhysiqueId}/{id}';

  /**
   * Renvoie la personne physique spécifiée liée à la plaque spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiquePlaquePersonnePhysiqueGetByPlaque()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiquePlaquePersonnePhysiqueGetByPlaque$Response(params: {

    /**
     * Identifiant de la plaque personne physique
     */
    plaquePersonnePhysiqueId: number;

    /**
     * Identifiant de la liaison de la plaque à une personne physique
     */
    id: number;
  }): Observable<StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesPlaquesService.PersonnePhysiquePlaquePersonnePhysiqueGetByPlaquePath, 'get');
    if (params) {
      rb.path('plaquePersonnePhysiqueId', params.plaquePersonnePhysiqueId, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Renvoie la personne physique spécifiée liée à la plaque spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiquePlaquePersonnePhysiqueGetByPlaque$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiquePlaquePersonnePhysiqueGetByPlaque(params: {

    /**
     * Identifiant de la plaque personne physique
     */
    plaquePersonnePhysiqueId: number;

    /**
     * Identifiant de la liaison de la plaque à une personne physique
     */
    id: number;
  }): Observable<PersonnePhysiquePlaquePersonnePhysiqueDto> {

    return this.personnePhysiquePlaquePersonnePhysiqueGetByPlaque$Response(params).pipe(
      map((r: StrictHttpResponse<PersonnePhysiquePlaquePersonnePhysiqueDto>) => r.body as PersonnePhysiquePlaquePersonnePhysiqueDto)
    );
  }

}
